module.exports = __webpack_public_path__ + "img/BUSINESS_SOLUTION_color.17dbbb09.svg";